import { writable } from 'svelte/store';

export const open_setting = writable('');

function create_loading_schedules() {
	const { subscribe, set } = writable(false);

	const store = {
		set,
		subscribe,
		true: () => {
			store.set(true);
		},
		false: () => {
			store.set(false);
		},
	};

	return store;
}

export const loading_schedules = create_loading_schedules();
